
import React, { Component } from 'react'

const type = localStorage.getItem("type");



class AllusersButton extends Component {
    onFormSubmit(event)
    {
      event.preventDefault();
        window.location.replace("/Allusers");
        
    }

	render() {
        if (type === "boss"){
            return (
                <div>
               <form onSubmit={this.onFormSubmit}  id="allbutton" >
                 <div>
                 
                    <button class="btn btn-dark button2 "  >
                   
                        All Users
                      </button>
                      
                      </div>
                    </form>
              </div>
              
            )
        }
		
	}
}

export default AllusersButton

